import React, {useEffect, useMemo} from "react";
import QStyles from "../styles/components/QuestionTimer.module.css";

/**
 * QuestionTimer
 *
 * A presentational countdown progress bar with a mm:ss label on the right.
 * It does NOT keep time itself. Pass `totalMs` and `remainingMs` from a parent
 * that owns the timer logic. This component will render and smoothly animate
 * the bar width based on those props.
 *
 * Props:
 * - totalMs: number (total duration in milliseconds)
 * - remainingMs: number (time remaining in milliseconds)
 * - className?: string (optional container classes)
 * - warnAt?: number (0–1 ratio where color changes to warning; default 0.2)
 * - dangerAt?: number (0–1 ratio where color changes to danger; default 0.1)
 * - showTime?: boolean (show mm:ss label; default true)
 * - ariaLabel?: string (accessibility label)
 */
const QuestionTimer = ({
                           totalMs,
                           remainingMs,
                           className = "",
                           warnAt = 0.2,
                           dangerAt = 0.1,
                           showTime = true,
                           ariaLabel = "Time remaining",
                       }) => {
    const { ratio, timeStr, barClass } = useMemo(() => {
        const total = Math.max(1, Number(totalMs) || 0);
        const remaining = Math.max(0, Math.min(Number(remainingMs) || 0, total));
        const r = remaining / total;

        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const tStr = `${minutes}:${String(seconds).padStart(2, "0")}`;

        let cls = QStyles.barGreen;
        if (r <= dangerAt) cls = QStyles.barRed;
        else if (r <= warnAt) cls = QStyles.barAmber;

        return { ratio: r, timeStr: tStr, barClass: cls };
    }, [totalMs, remainingMs, warnAt, dangerAt]);

    const pct = Math.max(0, Math.min(1, ratio)) * 100;

    return (
        <div className={`${QStyles.container} ${className}`}>

            {showTime && <div className={QStyles.time}>{timeStr}</div>}

            {/*<div*/}
            {/*    className={QStyles.track}*/}
            {/*    role="progressbar"*/}
            {/*    aria-label={ariaLabel}*/}
            {/*    aria-valuemin={0}*/}
            {/*    aria-valuemax={100}*/}
            {/*    aria-valuenow={Math.round(pct)}*/}
            {/*>*/}
            {/*    <div*/}
            {/*        className={`${QStyles.bar} ${barClass}`}*/}
            {/*        style={{*/}
            {/*            width: `${pct.toFixed(3)}%`,*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <div className={QStyles.overlay} />*/}
            {/*</div>*/}


        </div>
    );
};

export default QuestionTimer;
